import { Pipe, PipeTransform } from '@angular/core';
import { UpdateAppointmentHistoryJobDetails } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';

@Pipe({
    name: 'StringToJobDetailsTablePipe'
})
export class StringToJobDetailsTablePipe implements PipeTransform {

    constructor(
    ) { 
        // This is intentional
    } 

    transform(deatils: any,isAdditional: boolean): any {
        const arra =[]
        deatils.forEach(element => {
          if(element?.toString().includes(",")){
          let obj:UpdateAppointmentHistoryJobDetails={
            description:"",
            jobId:0,
            costType:'',
            fixedPrice:0,
            partInStock:0,
            qty:0,
            salesPart:0,
            salesPriceExcVAT:0,
            salesPriceInclVAT:0,
            totalTime:0,
            unitPrice:0
          }
          let arr = element.split(",");
          if(arr && arr.length >0 && !isAdditional){
            obj.costType = arr[1];
            obj.jobId = +arr[0];
            obj.salesPart = arr[2];
            obj.description = arr[3];
            obj.partInStock = arr[4];
            obj.qty = arr[5];
            obj.unitPrice = arr[6];
            obj.salesPriceExcVAT = arr[7];
            obj.salesPriceInclVAT = arr[8];
            obj.fixedPrice = arr[9];
          }
          if(arr && arr.length >0 && isAdditional){
            obj.costType = arr[1];
            obj.jobId = +arr[0];
            obj.salesPart = arr[2];
            obj.description = arr[3];
            obj.qty = arr[5];
            obj.salesPriceInclVAT = arr[6];
            obj.fixedPrice = arr[7];
          }
          arra.push(obj);
        }
           
        })
        return arra;
        
    }
}


